'use strict'
const Base = require('../base.edit')
const ImageResize = require('../../helpers/image-resize')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))
const ajax = require('../../helpers/ajax')

module.exports = class pureHtmlWidget extends Base {

	onInit() {

		if (!this._data.url) { this._data.url = '' }

		let input = document.createElement('input')
		input.type = 'file'
		input.onchange = () => {
			this.popup(input.files[0])
			input.value = ''
		}

		let innerImg = this._widget.querySelector('img')
		innerImg.onclick = () => {
			input.click()
		}

		let label = document.createElement('label')
		label.innerHTML = '<i class="material-icons">add_a_photo</i>'
		label.appendChild(input)
		this._elemButtons.appendChild(label)

		this.config = {
			width: this._config.width,
			height: this._config.height,
			padding: 200,
		}

		let link = document.createElement('button')
		link.className = 'formater'
		link.onclick = this.formLink.bind(this)
		this.btnLink = link
		this.btnTextLink()
		this._elemButtons.appendChild(link)

		let title = document.createElement('button')
		title.className = 'formater'
		title.onclick = this.formTitle.bind(this)
		this.btnLink = title
		this.btnTitleLink()
		this._elemButtons.appendChild(title)

	}

	onDestroy() {}

	btnTextLink() {
		this.btnLink.innerHTML = '<i class="material-icons">link</i> &nbsp; ' +
			this._data.url || ''
	}

	btnTitleLink() {
		this.btnLink.innerHTML = '<i class="material-icons">title</i> &nbsp; ' +
			this._data.title || ''
	}

	formLink() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		text.value = this._data.url
		div.appendChild(forms.input('Po kliku otvoriť stránku', text))


		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			this._data.url = text.value ? text.value.trim() : ''
			this._render()
			modal.hide()
			this.btnTextLink()

		}
		block.appendChild(forms.actions(button))

		let title = 'Nastavenia'
		modal.show(title, block).then(() => { text.focus() })

	}

	formTitle() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		text.value = this._data.title
		div.appendChild(forms.input('Po kliku otvoriť stránku', text))


		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			this._data.title = text.value ? text.value.trim() : ''
			this._render()
			modal.hide()
			this.btnTitleLink()

		}
		block.appendChild(forms.actions(button))

		let title = 'Nastavenia'
		modal.show(title, block).then(() => { text.focus() })

	}

	popup(file) {
		let title = 'Nahrajte obrazok'
		let block = document.createElement('div')
		block.className = 'uploader'

		this.IR = new ImageResize(this.config)
		this.IR.setFile(file)
		this.IR.setWrapper(block)
		modal.show(title, block)

		let btn = document.createElement('button')
		btn.innerHTML = '<i class="material-icons">done</i>'
		btn.className = 'btn'
		btn.onclick = () => {
			this.IR.done(blob => {
				// this._widget.querySelector('img').src = img
				ajax({
					url: '/api/upload/',
					method: 'PUT',
					data: blob,
				}).then(resp => {
					this._data.img = resp.path
					this._render()
				})
				modal.hide()
			})
		}
		block.appendChild(btn)
		this.setPopupSize(block, btn)
	}

	setPopupSize(block, btn) {

		const w = this.config.width + this.config.padding
		const h = this.config.height + this.config.padding
		const maxw = window.innerWidth * 0.9
		const maxh = window.innerHeight * 0.9 - 100

		let zoom = 1
		if (maxw / w < zoom) { zoom = maxw / w }
		if (maxh / h < zoom) { zoom = maxh / h }

		block.style.width = w + 'px'
		block.style['min-height'] = h + 'px'
		block.style.zoom = zoom
		btn.style.zoom = 1 / zoom

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/image-for-image-widget-szts/image-for-image-widget-szts.edit.js
// module id = 459
// module chunks = 0